import state from '@/store/modules/bs_inf/state'
import actions from '@/store/modules/bs_inf/actions'
import mutations from '@/store/modules/bs_inf/mutations'
import getters from '@/store/modules/bs_inf/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
